import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import useCustomerReducer from '../useCustomerReducer';
import Stack from '@mui/material/Stack';
import AccountSellerCard from './components';
import useIsMobile from '../components/useIsMobile';
const AccountSeller = () => {
    const isMoble = useIsMobile();
    const [{ customer }] = useCustomerReducer();
    const seller = useMemo(() => (customer === null || customer === void 0 ? void 0 : customer.accountManager) || (customer === null || customer === void 0 ? void 0 : customer.seller), [customer]);
    return seller ? (_jsx(Stack, Object.assign({ direction: isMoble ? 'column' : 'row' }, { children: _jsx(AccountSellerCard, {}) }))) : (_jsx(_Fragment, {}));
};
export default AccountSeller;
